
export type Retweet200 = {
  retweetCount?: number;
  success?: boolean;
};
